// src/components/auth/PrivateRoute.jsx
import React, { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useApp } from '../../context/AppContext';

const PrivateRoute = ({ children, requiresAssessment = false }) => {
  // AuthContext provides redirectToAuth (the DDD Auth Hub's sign-in, the
  // same place the Log In button goes). This used to call a
  // redirectToAuthHub that doesn't exist, so /profile threw for anyone
  // signed out and rendered a blank page.
  const { loading, isAuthenticated, redirectToAuth } = useAuth();
  const { assessmentResults } = useApp();

  useEffect(() => {
    // If not loading and not authenticated, send them to sign in
    if (!loading && !isAuthenticated) {
      redirectToAuth('signin');
    }
  }, [loading, isAuthenticated, redirectToAuth]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="text-center">
          <img src="/art-of-story-logo.svg" alt="The Art of Story" className="w-24 h-24 mx-auto mb-4 animate-pulse" />
          <div className="spinner mx-auto mb-4"></div>
          <p className="text-pearl/80">Loading your story journey...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Show loading while redirecting to sign in
    return (
      <div className="min-h-screen flex items-center justify-center bg-black">
        <div className="text-center">
          <img src="/art-of-story-logo.svg" alt="The Art of Story" className="w-24 h-24 mx-auto mb-4 animate-pulse" />
          <div className="spinner mx-auto mb-4"></div>
          <p className="text-pearl/80">Redirecting to sign in...</p>
        </div>
      </div>
    );
  }

  if (requiresAssessment && !assessmentResults) {
    // For now, just show the children - assessment requirement can be handled later
    // You might want to redirect to assessment or show a different message
    return children;
  }

  return children;
};

export default PrivateRoute;